<div class="login-header">
  <h2 class="login-title">Iniciar Sesión</h2>
</div>

@if (errorMessage) {
  <div class="error-message">
    {{ errorMessage }}
  </div>
}

@if (showResendVerification) {
  <div class="resend-notice">
    <p>¿No recibiste el código de verificación? 
      <button type="button" class="resend-link" (click)="resendVerificationCode()">
        Reenviar código
      </button>
    </p>
  </div>
}

<form class="login-form" (ngSubmit)="login()">
  <div class="form-group">
    <label for="email" class="form-label">Correo electrónico</label>
    <input 
      type="email" 
      id="email" 
      name="email" 
      class="form-input" 
      placeholder="name@gmail.com" 
      [(ngModel)]="email"
      [disabled]="isLoading"
      required
    >
  </div>
  
  <div class="form-group">
    <label for="password" class="form-label">Contraseña</label>
    <div class="password-input-wrapper">
      <input 
        [type]="showPassword ? 'text' : 'password'" 
        id="password" 
        name="password" 
        class="form-input" 
        [(ngModel)]="password"
        [disabled]="isLoading"
        required
      >
      <button type="button" class="eye-button" (click)="togglePasswordVisibility()" aria-label="Mostrar/ocultar contraseña" [attr.aria-pressed]="showPassword">
        <fa-icon [icon]="showPassword ? faEyeSlash : faEye"></fa-icon>
      </button>
    </div>
  </div>
  
  <button type="submit" class="login-button" [disabled]="isLoading">
    @if (isLoading) {
      <span>Iniciando sesión...</span>
    } @else {
      <span>Iniciar Sesión</span>
    }
  </button>
  
  <div class="login-footer">
    <p class="footer-text">¿No tienes cuenta? <a href="/register" class="footer-link">Regístrate</a></p>
  </div>
</form>